import { fetchPlantSheetFile } from '../../infrastructure/content/plantSheetFile';
import { SHARE_RESULTS, shareImage } from './shareImage';

/**
 * Share the plant's one-pager as a picture, and fall back to the link when the
 * picture cannot travel (SPEC-005 D-6).
 *
 * The ladder itself moved to `shareImage.js` when the app gained an invitation
 * card of its own (SPEC-020 D-5). What is left here is the part that was ever
 * about plants: which file, and what to say about it.
 *
 * `nav` and the loader stay defaulted parameters — the repo's rule for anything
 * touching a browser API, and what lets `sharePlantSheet.test.js` exercise every
 * branch of the ladder without a share sheet.
 */

export { SHARE_RESULTS };

export async function sharePlantSheet(
    { plantId, commonName, languageCode, title, text, url },
    { nav = typeof navigator === 'undefined' ? null : navigator, loadFile = fetchPlantSheetFile } = {},
) {
    return shareImage(
        { title, text, url },
        () => loadFile({ plantId, commonName, languageCode }),
        nav,
    );
}
